import useSWR from 'swr';

export default function useShowPricing() {
  const { data, error } = useSWR('/api/admin/settings', (url) =>
    fetch(url).then((res) => res.json())
  );
  return {
    showPricing: data?.showPricing ?? true,
    loading: !data && !error,
    error,
  };
}
